// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","logo":"Header_logo__shVBB","clinicAddress":"Header_clinicAddress__6bpP8"};